module.exports = __webpack_public_path__ + "static/media/systitle-xingjiongwulian.d356e16a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pic/systitle-xingjiongwulian.png
// module id = 1034
// module chunks = 58